import { render, staticRenderFns } from "./SPopUp.vue?vue&type=template&id=11475131&scoped=true"
import script from "./sPopUp.ts?vue&type=script&lang=ts&external"
export * from "./sPopUp.ts?vue&type=script&lang=ts&external"
import style0 from "./SPopUp.vue?vue&type=style&index=0&id=11475131&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11475131",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11475131')) {
      api.createRecord('11475131', component.options)
    } else {
      api.reload('11475131', component.options)
    }
    module.hot.accept("./SPopUp.vue?vue&type=template&id=11475131&scoped=true", function () {
      api.rerender('11475131', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-pop-up/SPopUp.vue"
export default component.exports